import { maestroApiCall } from '@michelin/central-provider';
import hash from 'object-hash';
import { useQuery } from 'react-query';
import { apigatewayBaseRoute as baseURL } from 'services/restApiConst';

export interface GetMacroApprovalLimitsParams {
  fleet_id?: string;
}

export interface MacroApprovalLimits {
  urban_admin_allow_preapproved_txs: boolean;
  urban_admin_preapproved_txs_limit_amount: string;
  urban_admin_preapproved_txs_no_limits: boolean;
  message?: string;
  error?: string;
}

export function useGetMacroApprovalLimits(params?: GetMacroApprovalLimitsParams) {
  return useQuery<MacroApprovalLimits | null>(
    ['useGetMacroApprovalLimits', hash(params ?? {})],
    () => {
      if (!params?.fleet_id) return null;
      return maestroApiCall(
        {
          method: 'POST',
          endpoint: 'approvalLimits/getApprovalLimits',
          baseURL,
        },
        params,
      );
    },
    {
      cacheTime: 3600,
    },
  );
}
